/**
 * Created by wenzi on 2017/6/12.
 */
/* personal */
export const IMG_AND_NAME = 'IMG_AND_NAME' // 头像及用户名
export const MY_REQUIREMENT = 'MY_REQUIREMENT' // 我的需求
/* evmpermit */
export const EVM_SET_VALUE = 'EVM_SET_VALUE'
export const EVM_SET_ORDERID = 'EVM_SET_ORDERID'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js